import React, { Component } from 'react';
import { connect } from 'react-redux';
import { AIRLINE_LANDINGPAGE as AIRLINE_LANDINGPAGE_TEMLATE } from 'routes/template/constants/templateKeys';
import PopularItemsComponent from './PopularItemsComponent';

class PopularItems extends Component {
  constructor(props) {
    super(props);

    this.handleOnClickPrevPackage = this.handleOnClickPrevPackage.bind(this);
    this.handleOnClickNextPackage = this.handleOnClickNextPackage.bind(this);
    this.assignCarouselRef = this.assignCarouselRef.bind(this);

    this.carouselRef = React.createRef();
  }

  handleOnClickPrevPackage() {
    if (this.props.items.length > 0) {
      this.slider && this.slider.slickPrev();
    }
  }

  handleOnClickNextPackage() {
    if (this.props.items.length > 0) {
      this.slider && this.slider.slickNext();
    }
  }

  assignCarouselRef(refValue) {
    this.slider = refValue;
  }

  render() {
    const { items, title, useRenderListProp, renderList: _renderList, template } = this.props;
    const hidePlaceholder = items.length > 0;
    const renderList = useRenderListProp ? _renderList : true;
    const isAirlineLandingTemplate = template === AIRLINE_LANDINGPAGE_TEMLATE;

    return (
      <PopularItemsComponent
        items={items}
        title={title}
        hidePlaceholder={hidePlaceholder}
        renderList={renderList}
        assignCarouselRef={this.assignCarouselRef}
        onClickPrevPackage={this.handleOnClickPrevPackage}
        onClickNextPackage={this.handleOnClickNextPackage}
        isAirlineLandingTemplate={isAirlineLandingTemplate}
      />
    );
  }
}

function mapStateToProps(state) {
  return {
    template: state.template.template,
  };
}

export default connect(mapStateToProps)(PopularItems);
